<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <p class="small text-muted">Items marked with <span class="text-danger">*</span> require a response.</p>

        <h6 class="text-muted text-uppercase small mb-2">Injury Checklist</h6>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuryDateTime">Date &amp; Time of Injury <span class="text-danger">*</span></label>
                    <wj-input-date-time
                        [(ngModel)]="target.injuryDateTime"
                        name="injuryDateTime"
                        id="injuryDateTime"
                        [isRequired]="true"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="job">Job #</label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuredEmployeeHrRef">Injured Employee Name <span class="text-danger">*</span></label>
                    <wj-combo-box
                        [(ngModel)]="target.injuredEmployeeHrRef"
                        name="injuredEmployeeHrRef"
                        id="injuredEmployeeHrRef"
                        [itemsSource]="employeeList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="location">Location of Injury</label>
                    <app-voice-text-field
                        [(ngModel)]="target.location"
                        name="location"
                        inputId="location"
                        [rows]="2"
                        [showLocationButton]="true"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="onCompanyProperty" name="onCompanyProperty" [(ngModel)]="target.onCompanyProperty" />
                    <label class="form-check-label" for="onCompanyProperty">Occurred on company property</label>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="onJobSite" name="onJobSite" [(ngModel)]="target.onJobSite" />
                    <label class="form-check-label" for="onJobSite">Occurred on job site</label>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="onHighway" name="onHighway" [(ngModel)]="target.onHighway" />
                    <label class="form-check-label" for="onHighway">Occurred on highway</label>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="onFreeway" name="onFreeway" [(ngModel)]="target.onFreeway" />
                    <label class="form-check-label" for="onFreeway">Occurred on freeway</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" id="policeNotified" name="policeNotified" [(ngModel)]="target.policeNotified" />
                    <label class="form-check-label" for="policeNotified">Police notified</label>
                </div>
                <div class="form-group">
                    <label for="policeReportNumber">Police Report #</label>
                    <input
                        type="text"
                        class="form-control"
                        id="policeReportNumber"
                        name="policeReportNumber"
                        [(ngModel)]="target.policeReportNumber"
                    />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check mb-2">
                    <input class="form-check-input" type="checkbox" id="fireEmsNotified" name="fireEmsNotified" [(ngModel)]="target.fireEmsNotified" />
                    <label class="form-check-label" for="fireEmsNotified">Fire / EMS notified</label>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="erWorkMedTreatment" name="erWorkMedTreatment" [(ngModel)]="target.erWorkMedTreatment" />
                    <label class="form-check-label" for="erWorkMedTreatment">ER / WorkMed clinic treatment</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="firstReportOfInjuryOnly"
                        name="firstReportOfInjuryOnly"
                        [(ngModel)]="target.firstReportOfInjuryOnly"
                    />
                    <label class="form-check-label" for="firstReportOfInjuryOnly">First report of injury only</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="death" name="death" [(ngModel)]="target.death" />
                    <label class="form-check-label" for="death">Death</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuredEmployeeFullSignature">Injured employee full signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="injuredEmployeeFullSignature"
                        name="injuredEmployeeFullSignature"
                        [(ngModel)]="target.injuredEmployeeFullSignature"
                    />
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">General Information</h6>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="employeeDateOfBirth">Employee date of birth</label>
                    <wj-input-date
                        [(ngModel)]="target.employeeDateOfBirth"
                        name="employeeDateOfBirth"
                        id="employeeDateOfBirth"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="hireDate">Date employee was hired</label>
                    <wj-input-date [(ngModel)]="target.hireDate" name="hireDate" id="hireDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="injuredPersonType">Injured person is</label>
                    <wj-combo-box
                        [(ngModel)]="target.injuredPersonType"
                        name="injuredPersonType"
                        id="injuredPersonType"
                        [itemsSource]="injuredPersonTypeList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isEditable]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="department">Department</label>
                    <input type="text" class="form-control" id="department" name="department" [(ngModel)]="target.department" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="jobTitle">Employee's job title</label>
                    <input type="text" class="form-control" id="jobTitle" name="jobTitle" [(ngModel)]="target.jobTitle" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="siteSuperintendent">Site superintendent</label>
                    <input type="text" class="form-control" id="siteSuperintendent" name="siteSuperintendent" [(ngModel)]="target.siteSuperintendent" />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="employeeSuperintendent">Employee superintendent</label>
                    <input
                        type="text"
                        class="form-control"
                        id="employeeSuperintendent"
                        name="employeeSuperintendent"
                        [(ngModel)]="target.employeeSuperintendent"
                    />
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="foreman">Foreman</label>
                    <input type="text" class="form-control" id="foreman" name="foreman" [(ngModel)]="target.foreman" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="reportedToSafetyDateTime">Date &amp; time reported to Safety Dept. <span class="text-danger">*</span></label>
                    <wj-input-date-time
                        [(ngModel)]="target.reportedToSafetyDateTime"
                        name="reportedToSafetyDateTime"
                        id="reportedToSafetyDateTime"
                        [isRequired]="true"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-check mt-4">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="dailyMeetingCompleted"
                        name="dailyMeetingCompleted"
                        [(ngModel)]="target.dailyMeetingCompleted"
                    />
                    <label class="form-check-label" for="dailyMeetingCompleted">Daily Safety Coordination Meeting completed prior to work beginning</label>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Statement Details</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="injuryDescription">Describe the injury (how it happened, what happened, what others were doing)</label>
                    <app-voice-text-field
                        [(ngModel)]="target.injuryDescription"
                        name="injuryDescription"
                        inputId="injuryDescription"
                        [rows]="4"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-6">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="postInjuryDrugTest" name="postInjuryDrugTest" [(ngModel)]="target.postInjuryDrugTest" />
                    <label class="form-check-label" for="postInjuryDrugTest">Post-injury drug test performed</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="unsafeWorkingConditions"
                        name="unsafeWorkingConditions"
                        [(ngModel)]="target.unsafeWorkingConditions"
                    />
                    <label class="form-check-label" for="unsafeWorkingConditions">Were there unsafe working conditions?</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuredEmployeeSignature">Signature of the injured employee</label>
                    <input
                        type="text"
                        class="form-control"
                        id="injuredEmployeeSignature"
                        name="injuredEmployeeSignature"
                        [(ngModel)]="target.injuredEmployeeSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="injuredEmployeeSignedOn">Signed On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.injuredEmployeeSignedOn"
                        name="injuredEmployeeSignedOn"
                        id="injuredEmployeeSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between mb-2 mt-3">
            <h6 class="text-muted text-uppercase small mb-0">Witnesses</h6>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addWitness()">
                <fa-icon [icon]="faPlus"></fa-icon> Add Witness
            </button>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="witnessToInjury" name="witnessToInjury" [(ngModel)]="target.witnessToInjury" />
                    <label class="form-check-label" for="witnessToInjury">Was there a witness to the injury?</label>
                </div>
            </div>
        </div>
        @if (target.witnesses.length === 0) {
            <p class="text-muted small">No witnesses added.</p>
        }
        @for (row of target.witnesses; track row.id; let i = $index) {
            <div class="card mb-2">
                <div class="card-body py-2">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong class="small">Witness {{ i + 1 }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeWitness(i)">
                            <fa-icon [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-6 form-group">
                            <label [for]="'witnessName_' + i">Witness name</label>
                            <input type="text" class="form-control" [id]="'witnessName_' + i" [name]="'witnessName_' + i" [(ngModel)]="row.name" />
                        </div>
                        <div class="col-md-6 form-group">
                            <label [for]="'witnessPhone_' + i">Witness phone number</label>
                            <input type="text" class="form-control" [id]="'witnessPhone_' + i" [name]="'witnessPhone_' + i" [(ngModel)]="row.phone" />
                        </div>
                    </div>
                    <div class="form-group mb-0">
                        <label [for]="'witnessStatement_' + i">Witness statement</label>
                        <app-voice-text-field
                            [(ngModel)]="row.statement"
                            [name]="'witnessStatement_' + i"
                            [inputId]="'witnessStatement_' + i"
                            [rows]="2"
                        ></app-voice-text-field>
                    </div>
                </div>
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Nature of Injury</h6>
        <div class="row mb-2">
            @for (option of natureOptions; track option; let i = $index) {
                <div class="col-md-4">
                    <div class="form-check mb-1">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'nature_' + i"
                            [name]="'nature_' + i"
                            [checked]="isSelected(target.natureOfInjury, option)"
                            (change)="toggleSelected('natureOfInjury', option)"
                        />
                        <label class="form-check-label" [for]="'nature_' + i">{{ option }}</label>
                    </div>
                </div>
            }
        </div>
        @if (isSelected(target.natureOfInjury, 'Other?')) {
            <div class="form-group">
                <label for="natureOfInjuryOther">Other nature of injury</label>
                <input type="text" class="form-control" id="natureOfInjuryOther" name="natureOfInjuryOther" [(ngModel)]="target.natureOfInjuryOther" />
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Mechanism of Injury</h6>
        <div class="row mb-2">
            @for (option of mechanismOptions; track option; let i = $index) {
                <div class="col-md-4">
                    <div class="form-check mb-1">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'mech_' + i"
                            [name]="'mech_' + i"
                            [checked]="isSelected(target.mechanismOfInjury, option)"
                            (change)="toggleSelected('mechanismOfInjury', option)"
                        />
                        <label class="form-check-label" [for]="'mech_' + i">{{ option }}</label>
                    </div>
                </div>
            }
        </div>
        @if (isSelected(target.mechanismOfInjury, 'Other')) {
            <div class="form-group">
                <label for="mechanismOfInjuryOther">Other mechanism of injury</label>
                <input
                    type="text"
                    class="form-control"
                    id="mechanismOfInjuryOther"
                    name="mechanismOfInjuryOther"
                    [(ngModel)]="target.mechanismOfInjuryOther"
                />
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Part of Body Injured or Affected</h6>
        <div class="row mb-2">
            @for (option of bodyPartOptions; track option; let i = $index) {
                <div class="col-md-4">
                    <div class="form-check mb-1">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'body_' + i"
                            [name]="'body_' + i"
                            [checked]="isSelected(target.bodyPartsInjured, option)"
                            (change)="toggleSelected('bodyPartsInjured', option)"
                        />
                        <label class="form-check-label" [for]="'body_' + i">{{ option }}</label>
                    </div>
                </div>
            }
        </div>
        @if (isSelected(target.bodyPartsInjured, 'Other?')) {
            <div class="form-group">
                <label for="bodyPartsInjuredOther">Other body part</label>
                <input type="text" class="form-control" id="bodyPartsInjuredOther" name="bodyPartsInjuredOther" [(ngModel)]="target.bodyPartsInjuredOther" />
            </div>
        }

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Employee Work Status</h6>
        <div class="row mb-2">
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="fullDutyNoRestrictions"
                        name="fullDutyNoRestrictions"
                        [(ngModel)]="target.fullDutyNoRestrictions"
                    />
                    <label class="form-check-label" for="fullDutyNoRestrictions">Full duty — no restrictions</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="modifiedLightDutyRequired"
                        name="modifiedLightDutyRequired"
                        [(ngModel)]="target.modifiedLightDutyRequired"
                    />
                    <label class="form-check-label" for="modifiedLightDutyRequired">Modified / light duty required</label>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="modifiedDutyDocumentSigned"
                        name="modifiedDutyDocumentSigned"
                        [(ngModel)]="target.modifiedDutyDocumentSigned"
                    />
                    <label class="form-check-label" for="modifiedDutyDocumentSigned">Modified duty document signed</label>
                </div>
            </div>
        </div>

        <h6 class="text-muted text-uppercase small mb-2 mt-3">Root Cause &amp; Corrective Action</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="rootCause">What was the cause of the injury?</label>
                    <app-voice-text-field [(ngModel)]="target.rootCause" name="rootCause" inputId="rootCause" [rows]="3"></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="correctiveAction">Corrective action</label>
                    <app-voice-text-field
                        [(ngModel)]="target.correctiveAction"
                        name="correctiveAction"
                        inputId="correctiveAction"
                        [rows]="3"
                    ></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="primaryCause">Primary cause of the accident (Safety Department)</label>
                    <app-voice-text-field [(ngModel)]="target.primaryCause" name="primaryCause" inputId="primaryCause" [rows]="2"></app-voice-text-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="documentCompleteSignature">Document complete — injured employee signature</label>
                    <input
                        type="text"
                        class="form-control"
                        id="documentCompleteSignature"
                        name="documentCompleteSignature"
                        [(ngModel)]="target.documentCompleteSignature"
                    />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="documentCompleteSignedOn">Signed On</label>
                    <wj-input-date-time
                        [(ngModel)]="target.documentCompleteSignedOn"
                        name="documentCompleteSignedOn"
                        id="documentCompleteSignedOn"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label>Attachments</label>
                @for (url of target.imageUrls; let i = $index; track i + '|' + url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img
                            style="max-width: 250px; cursor: pointer"
                            [src]="getExistingFileSrc(url)"
                            (click)="openExistingFile(url)"
                            alt=""
                        />
                        <div class="small text-muted mt-1">{{ displayFileName(i) }}</div>
                    </div>
                }
            </div>
        }
        @if (attachments && attachments.length > 0) {
            <div class="row">
                <label>Files To Upload</label>
                @for (file of attachments; track file) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeAttachment(file)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="getPendingFileSrc(file)" />
                        <div class="small text-muted mt-1">{{ file.name }}</div>
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Photos / Documents</button>
        <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
            #fileInput
            multiple
        />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
